import React from 'react'
import { removeKeywordSuffix } from 'containers/VerticalPage/common/utils'
import columns, { ColumnTitleWithTooltip } from 'UI/VerticalTable/columns'
import { COLUMNS_IDS } from 'UI/VerticalTable/utils'
import { ITableColumnsType } from 'uikit/tables/default'

export const ecommerceExtendedColumns: ITableColumnsType<any> = [
  {
    ...columns[COLUMNS_IDS.profileNames],
    title: <ColumnTitleWithTooltip title='Online Name' tooltipText='Names used by entity/individual online' />,
  },
  { ...columns[COLUMNS_IDS.verifiedName], minWidth: 150 },
  columns[COLUMNS_IDS.tin],
  columns[COLUMNS_IDS.ecommerceTaxCollection],
  columns[COLUMNS_IDS.ecommerceSellerRegStatus],
  columns[COLUMNS_IDS.ecommerceRegistry],
  columns[COLUMNS_IDS.ecommerceRiskScore],
  columns[COLUMNS_IDS.ecommerceMagnitudeScore],
  columns[COLUMNS_IDS.dataSources],
  columns[COLUMNS_IDS.firstActivity],
  columns[COLUMNS_IDS.ecommerceShopCategories],
  columns[COLUMNS_IDS.ecommerceAddressNexus],
  columns[COLUMNS_IDS.ecommerceEmployeesNexus],
  columns[COLUMNS_IDS.ecommerceNumberOfShops],
  columns[COLUMNS_IDS.ecommerceAddresses],
  columns[COLUMNS_IDS.websiteRanking],
  columns[COLUMNS_IDS.ecommerceNumberOfEmployees],
  columns[COLUMNS_IDS.ecommerceAvgMonthlyCountryTraffic],
  columns[COLUMNS_IDS.ecommerceAvgMonthlyTraffic],
  columns[COLUMNS_IDS.caseId],
]

export const keysForEmptyColumnsRequest = removeKeywordSuffix(
  ecommerceExtendedColumns.map(el => `${el.key}` || '').filter(key => Boolean(key)),
)
